export default {
  Codigo: null,
  Descripcion: null,
  Abreviatura: null,
  EsUnidadVenta: null,
  EsUnidadInventario: null,
  Activo: true,
};
